<template>
  <widget
    :color="color"
    icon="fa fa-robot"
    :title="`Success ${direction === 'inbound' ? 'inbound' : 'outbound'} calls`"
    :percent="percent"
    :value="value"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget9'

export default {
  components: {
    Widget
  },
  props: {
    refresh: Boolean,
    direction: String
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      percent: 0,
      value: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getSessionSuccess()
      }
    }
  },
  methods: {
    async getSessionSuccess() {
      try {
        const success = await apiRealtime.getVoiceSessionSuccess({
          direction: this.direction
        })

        this.value = success.total
        this.percent = success.percent

        this.$emit('reset', 'voiceSessionSuccess')
      } catch (error) {}
    }
  }
}
</script>
